import React from "react";
import HotelsSearchMockupPage from "../../features/hotelsSearchMockup/HotelsSearchMockupPage";

/** Hotels-only mockup — search → results → room combo → Pre-Book → Book (Hubwayz). */
export default function HotelsSearchMockupStandalonePage() {
  return <HotelsSearchMockupPage />;
}
